import React, { useState, useEffect, useMemo } from "react";
import Grid from "@material-ui/core/Grid";
import {
  getAutocompleteLabel,
  normalizeAutocompleteValue,
} from "../../../utils/autocomplete";
import Typography from "@material-ui/core/Typography";
import TextField from "@material-ui/core/TextField";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Checkbox from "@material-ui/core/Checkbox";
import MenuItem from "@material-ui/core/MenuItem";
import Select from "@material-ui/core/Select";
import { makeStyles } from "@material-ui/core/styles";
import Button from "@material-ui/core/Button";
import FormControl from "@material-ui/core/FormControl";
import InputLabel from "@material-ui/core/InputLabel";
import moment, { add } from "moment";
import Autocomplete, {
  createFilterOptions,
} from "@material-ui/lab/Autocomplete";
import DateFnsUtils from "@date-io/date-fns"; // choose your lib
import {
  DatePicker,
  TimePicker,
  DateTimePicker,
  MuiPickersUtilsProvider,
  KeyboardDatePicker,
} from "@material-ui/pickers";
import "date-fns";
import { ca } from "date-fns/locale";

//Estilos
const useStyles = makeStyles((theme) => ({
  formControl: {
    margin: theme.spacing(1),
    width: `calc(100% - ${theme.spacing(2)}px)`,
    minWidth: 0,
  },
  formControl2: {
    margin: theme.spacing(1),
    width: `calc(100% - ${theme.spacing(2)}px)`,
    minWidth: 0,
  },
  selectEmpty: {
    marginTop: theme.spacing(2),
  },
  container: {
    display: "flex",
    flexWrap: "wrap",
    width: `calc(100% - ${theme.spacing(2)}px)`,
    minWidth: 0,
    margin: theme.spacing(1),
  },
  buttons: {
    display: "flex",
    justifyContent: "flex-end",
  },
  button: {
    marginTop: theme.spacing(3),
    marginLeft: theme.spacing(1),
  },
}));

const ORDEN_DIAS_TURNO = [
  ["LUNES", 0],
  ["MARTES", 1],
  ["MIÉRCOLES", 2],
  ["MIERCOLES", 2],
  ["JUEVES", 3],
  ["VIERNES", 4],
  ["SÁBADO", 5],
  ["SABADO", 5],
  ["DOMINGO", 6],
];

function getTurnoSortKeys(turno) {
  const etiqueta = String(turno?.label || "").toUpperCase();
  const dia = ORDEN_DIAS_TURNO.find(([nombre]) => etiqueta.includes(nombre));
  const hora = `${etiqueta} ${turno?.horaInicio || ""}`.match(
    /\b([01]?\d|2[0-3]):([0-5]\d)\b/
  );

  return {
    dia: dia ? dia[1] : 7,
    nombreDia: dia ? dia[0] : "Otros turnos",
    minutos: hora ? Number(hora[1]) * 60 + Number(hora[2]) : Number.MAX_SAFE_INTEGER,
  };
}

function getTurnoLabel(turno) {
  if (typeof turno === "string") return turno.replace(/\s*\|\s*/g, " – ");
  return String(turno?.label || "").replace(/\s*\|\s*/g, " – ");
}

export default function ViajeDetalles(props) {
  const classes = useStyles();
  const filter = createFilterOptions();
  const filtrarTurnos = createFilterOptions({ limit: 100 });
  const turnosOrdenados = useMemo(() => {
    const turnos = Array.isArray(props.values.turnos) ? props.values.turnos : [];

    return turnos
      .filter((turno) => turno?.label && turno.label !== "NO APLICA")
      .slice()
      .sort((a, b) => {
        const ordenA = getTurnoSortKeys(a);
        const ordenB = getTurnoSortKeys(b);
        return (
          ordenA.dia - ordenB.dia ||
          ordenA.minutos - ordenB.minutos ||
          String(a.label).localeCompare(String(b.label), "es")
        );
      });
  }, [props.values.turnos]);
  const turnoSeleccionado = turnosOrdenados.find(
    (turno) => String(turno.value) === String(props.values.turno)
  ) || null;
  // console.log(props.values);
  return (
    <React.Fragment>
      <Typography variant="h6" gutterBottom>
        Información del viaje
      </Typography>

      <Grid container spacing={3}>
        {props.values.perfilLog == 5 ? (
          <Grid item xs={12}>
            <FormControl className={classes.formControl2}>
              <Autocomplete
                fullWidth
                value={normalizeAutocompleteValue(props.values.idClienteSol, "nombre")}
                onChange={(event, newValue) => {
                  if (typeof newValue === "string") {
                    props.handleClientes(newValue);
                  } else if (newValue && newValue.inputValue) {
                    // Create a new value from the user input
                    props.handleClientes(newValue.inputValue);
                  } else {
                    props.handleClientes(newValue);
                  }
                }}
                filterOptions={(options, params) => {
                  const filtered = filter(options, params);

                  // Suggest the creation of a new value
                  if (params.inputValue !== "") {
                    filtered.push({
                      inputValue: params.inputValue,
                      nombre: `Usar: "${params.inputValue}"`,
                    });
                  }

                  return filtered;
                }}
                selectOnFocus
                clearOnBlur
                handleHomeEndKeys
                id="free-solo-with-text-demo"
                options={props.values.clientes}
                getOptionLabel={(option) => getAutocompleteLabel(option, "nombre")}
                renderOption={(option) => option.nombre}
                // style={{ width: 300 }}
                freeSolo
                renderInput={(params) => (
                  <TextField
                    {...params}
                    fullWidth
                    label="Escribe el Cliente que solicita"
                    variant="outlined"
                  />
                )}
              />
            </FormControl>
            <FormControlLabel
              control={
                <Checkbox
                  checked={props.values.urgente}
                  onChange={(event) =>
                    props.handleUrgente(event.target.checked)
                  }
                />
              }
              label="Urgente"
            />
            <FormControlLabel
              control={
                <Checkbox
                  checked={props.values.alta}
                  onChange={(event) => props.handleAlta(event.target.checked)}
                />
              }
              label="Alta"
            />
            <FormControlLabel
              control={
                <Checkbox
                  checked={props.values.ingres}
                  onChange={(event) => props.handleIngres(event.target.checked)}
                />
              }
              label="Ingres"
            />
          </Grid>
        ) : null}

        <Grid item xs={12}>
          <FormControl className={classes.formControl2}>
            <InputLabel id="demo-simple-select-label">
              Selecciona el tipo de vehículo
            </InputLabel>
            <Select
              fullWidth
              labelId="demo-simple-select-label"
              id="demo-simple-select"
              value={props.values.tipo}
              name="tipo"
              onChange={(e) => props.handleVehiculo(e.target.value)}
            >
              <MenuItem value={"TURISME"}>TURISME</MenuItem>
              <MenuItem value={"ADAPTAT"}>ADAPTAT</MenuItem>
            </Select>
          </FormControl>
        </Grid>

        {/* <Grid item xs={12}>
          <FormControl className={classes.formControl2}>
            <InputLabel id="demo-simple-select-label">
              Selecciona centro de asistencia
            </InputLabel>
            <Select
              labelId="demo-simple-select-label"
              id="demo-simple-select"
              value={props.values.direccionHospital}
              onChange={(e) => props.handleDestino(e.target.value)}
            >
              <MenuItem value={"LLEIDA SISTEMAS RENALES"}>
                LLEIDA SISTEMAS RENALES
              </MenuItem>
              <MenuItem value={"LLEIDA TORNS ARNAU"}>
                LLEIDA TORNS ARNAU
              </MenuItem>
              <MenuItem value={"IGUALADA"}>IGUALADA</MenuItem>
            </Select>
          </FormControl>
        </Grid> */}
        <Grid item xs={12}>
          <FormControl className={classes.formControl2}>
            <Autocomplete
              fullWidth
              value={normalizeAutocompleteValue(props.values.destino)}
              onChange={(event, newValue) => {
                if (typeof newValue === "string") {
                  props.handleDestino(newValue);
                } else if (newValue && newValue.inputValue) {
                  // Create a new value from the user input
                  props.handleDestino(newValue.inputValue);
                } else {
                  props.handleDestino(newValue);
                }
              }}
              filterOptions={(options, params) => {
                const filtered = filter(options, params);

                // Suggest the creation of a new value
                if (params.inputValue !== "") {
                  filtered.push({
                    inputValue: params.inputValue,
                    title: `Usar: "${params.inputValue}"`,
                  });
                }

                return filtered;
              }}
              selectOnFocus
              clearOnBlur
              handleHomeEndKeys
              id="free-solo-with-text-demo"
              options={props.values.todosDestinos}
              getOptionLabel={(option) => getAutocompleteLabel(option)}
              renderOption={(option) => option.title}
              // style={{ width: 300 }}
              freeSolo
              renderInput={(params) => (
                <TextField
                  {...params}
                  fullWidth
                  label="Escribe un pueblo destino"
                  variant="outlined"
                />
              )}
            />
          </FormControl>
        </Grid>
        <Grid item xs={12}>
          <FormControl className={classes.formControl2}>
            {/*    <TextField
              required
              id="city"
              name="city"
              label="Centro de asistencia"
              fullWidth
              autoComplete="shipping address-level2"
              onChange={props.handleData("direccionHospital")}
              defaultValue={props.values.direccionHospital}
            /> */}
            <Autocomplete
              fullWidth
              value={normalizeAutocompleteValue(props.values.direccionHospital)}
              onChange={(event, newValue) => {
                if (typeof newValue === "string") {
                  props.handleCentros(newValue);
                } else if (newValue && newValue.inputValue) {
                  // Create a new value from the user input
                  props.handleCentros(newValue.inputValue);
                } else {
                  props.handleCentros(newValue);
                }
              }}
              filterOptions={(options, params) => {
                const filtered = filter(options, params);

                // Suggest the creation of a new value
                if (params.inputValue !== "") {
                  filtered.push({
                    inputValue: params.inputValue,
                    title: `Usar: "${params.inputValue}"`,
                  });
                }

                return filtered;
              }}
              selectOnFocus
              clearOnBlur
              handleHomeEndKeys
              id="free-solo-with-text-demo"
              options={props.values.todosCentros}
              getOptionLabel={(option) => getAutocompleteLabel(option)}
              renderOption={(option) => option.title}
              // style={{ width: 300 }}
              freeSolo
              renderInput={(params) => (
                <TextField
                  {...params}
                  fullWidth
                  label="Escribe el Centro de Asistencia"
                  variant="outlined"
                />
              )}
            />
          </FormControl>
        </Grid>

        <Grid item xs={12}>
          <FormControl className={classes.formControl2}>
            <Autocomplete
              fullWidth
              id="dialisis-turno-autocomplete"
              options={turnosOrdenados}
              value={turnoSeleccionado}
              getOptionLabel={getTurnoLabel}
              getOptionSelected={(option, value) =>
                String(option.value) === String(value.value)
              }
              groupBy={(turno) => getTurnoSortKeys(turno).nombreDia}
              filterOptions={filtrarTurnos}
              ListboxProps={{ style: { maxHeight: 260 } }}
              noOptionsText="No hay turnos que coincidan"
              onChange={(_, turno) =>
                props.handleTurno(turno?.value || "", props.values.turnos)
              }
              renderOption={(turno) => (
                <Typography variant="body2">{getTurnoLabel(turno)}</Typography>
              )}
              renderInput={(params) => (
                <TextField
                  {...params}
                  required
                  fullWidth
                  variant="outlined"
                  label="Selecciona un turno"
                  helperText="Ordenados por día y hora. Escribe para buscar."
                />
              )}
            />
          </FormControl>
        </Grid>
        <Grid item xs={12}>
          <FormControl className={classes.container}>
            <MuiPickersUtilsProvider utils={DateFnsUtils} locale={ca}>
              <KeyboardDatePicker
                fullWidth
                margin="normal"
                id="date-picker-dialog"
                label="Selecciona una fecha"
                format="dd/MM/yyyy"
                value={props.values.fecha}
                onChange={(date) => props.handleConfirm(date)}
                KeyboardButtonProps={{
                  "aria-label": "change date",
                }}
                ampm={false}
              />
            </MuiPickersUtilsProvider>
          </FormControl>
        </Grid>
        <Grid item xs={12}>
          <FormControl className={classes.formControl}>
            <TextField
              id="city"
              name="city"
              disabled
              label="Seleccionaste:"
              fullWidth
              autoComplete="shipping address-level2"
              value={props.values.fechaMostrar}
            />
          </FormControl>
        </Grid>
      </Grid>
      <div className={classes.buttons}>
        {props.activeStep !== 0 && (
          <Button onClick={props.prevStep} className={classes.button}>
            Regresar
          </Button>
        )}
        <Button
          variant="contained"
          color="primary"
          onClick={props.nextStep}
          className={classes.button}
        >
          {props.activeStep === 4 && props.activeStep < 5
            ? "Solicitar viaje"
            : "Siguiente"}
        </Button>
      </div>
    </React.Fragment>
  );
}
